export class IdiomaModel {
    CODIGO: string;
    TITULO: string;
    FLAG: string;

    constructor(CODIGO, TITULO, FLAG) {
        this.CODIGO = CODIGO;
        this.TITULO = TITULO;
        this.FLAG = FLAG;
     }

     static carregarIdioma(idioma) {
         if (idioma === 'pt') {
             return new IdiomaModel('pt', 'Português', 'flag-icon-br');
         } else if (idioma === 'es') {
             return new IdiomaModel('es', 'Español', 'flag-icon-es');
         } else {
             return new IdiomaModel('en', 'English', 'flag-icon-us');
         }
     }

     static carregarIdiomas() {
        const idiomas = new Array();

        idiomas.push(new IdiomaModel('pt', 'Português', 'flag-icon-br'));
        idiomas.push(new IdiomaModel('en', 'English', 'flag-icon-us'));
        idiomas.push(new IdiomaModel('es', 'Español', 'flag-icon-es'));

        return idiomas;
     }
}
